export function infoCardsList() {
    $(".info-cards-list .button.more-details").on('click', function () {
        const $this = $(this);
        $this.closest(".item").toggleClass("active");
        if ($this.closest(".item").hasClass("active")) {
            $this.text("Hide details");
        } else {
            $this.text("More details");
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/infoCardsList.js